export default __webpack_public_path__ + "06c861965bdc3e7d55fd323805f7372e.svg";